// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { collection, getDocs } from "firebase/firestore"; // for Cloud Firestore
import { getFirestore } from 'firebase/firestore'; // for Cloud Firestore
import { getStorage, ref, getDownloadURL } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBvqCgJwLYk0B_m-pla861OfShZ_6c6Wgk",
  authDomain: "afrika-link-13ad9.firebaseapp.com",
  projectId: "afrika-link-13ad9",
  storageBucket: "afrika-link-13ad9.firebasestorage.app",
  messagingSenderId: "1014848099372",
  appId: "1:1014848099372:web:d430fdb02058b821f12d89",
  measurementId: "G-8G8JBLY9DQ"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig); // replace `firebaseConfig` with your config object
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

// Firebase Analytics is only initialized once the visitor has given cookie
// consent (see CookieConsent component) — never eagerly on module load.
let analytics = null;

const enableAnalytics = async () => {
  if (analytics || !(await isSupported())) return analytics;
  analytics = getAnalytics(firebaseApp);
  return analytics;
};

export { auth, enableAnalytics, signInWithEmailAndPassword, db, collection, getDocs, storage, ref, getDownloadURL }; // Add other functions you need
